var Marionette = require('backbone.marionette');

var PasswordConfirmation = Marionette.View.extend({
    template: require('../../templates/documents/password-confirmation.html'),

    ui: {
        modal: '#password-confirmation-modal',
        btn: '#sign-button',
        close: '#close',
        passwordGroup: '#password-group',
        plainPassword: '#plain-password',
        messagePassword: '#message-password'
    },
    events: {
        'click @ui.btn': 'signDocument',
        'keypress': 'onKeyPress',
        'click @ui.close': 'close'
    },

    initialize: function (options) {
        _.bindAll(this, 'signDocument');
        if (options.action)
            this.action = options.action;
        if (options.id)
            this.id = options.id;
    },
    signDocument: function () {
        if (this.ui.plainPassword.val() != "") {
            if (this.id)
                this.action(this.id, 'SIGNED', this.ui.plainPassword.val());
            else if (this.ids) {
                this.action(this.fn, this.ids, this.ui.plainPassword.val());
            } else {
                console.log("id and ids ia empty");
            }
            this.ui.modal.modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        } else {
            this.ui.passwordGroup.addClass('has-error');
            this.ui.messagePassword.text("Password can't be empty.");
        }
    },
    onKeyPress: function (e) {
        if (e.keyCode == 13)
            this.signDocument();
    },
    setDocumentId: function (id) {
        this.id = id;
    },
    setAction: function (action) {
        this.action = action;
    },
    showPasswordConfirmation: function () {
        this.ui.modal.modal({backdrop: 'static', keyboard: false});
    },
    setIds: function (ids) {
        this.ids = ids;
    },
    setFn: function (fn) {
        this.fn = fn;
    },
    setCancelAction: function (action) {
        this.cancelAction = action;
    },

    close: function() {
        if (_.isFunction(this.cancelAction)) {
            this.cancelAction();
        }
        this.ui.modal.modal('hide');
    }
});

module.exports = PasswordConfirmation;


//////////////////
// WEBPACK FOOTER
// ./app/views/documents/password-confirmation.js
// module id = 312
// module chunks = 0